
export default function BenefitsSection() {
  const stats = [
    { number: '40%', label: 'Reduction in Operational Costs' },
    { number: '3x', label: 'Faster Decision Making' },
    { number: '60%', label: 'Increase in Productivity' },
    { number: '24/7', label: 'Automated Operations' }
  ];

  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-red-900 to-red-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Measurable Business Transformation Results with AI Solutions
          </h2>
          <p className="text-xl text-red-100 max-w-3xl mx-auto">
            Our <strong>Charlotte NC AI solutions</strong> deliver quantifiable <strong>business intelligence</strong>, <strong>predictive analytics</strong>, and <strong>ROI improvements</strong> to your operations, helping you scale efficiently with <strong>business automation AI</strong> and <strong>data-driven strategies</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-red-300 mb-2">
                {stat.number}
              </div>
              <div className="text-lg text-red-100">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              Transform Your Charlotte NC Business Operations with AI
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-double-line text-green-400 text-xl"></i>
                </div>
                <div>
                  <strong className="text-red-200">Instant Business Intelligence &amp; Predictive Analytics:</strong> Get real-time visibility into your revenue, costs, and cash flow with <strong>AI solutions</strong> that provide <strong>predictive analytics</strong>, <strong>financial forecasting</strong>, and help you make <strong>data-driven decisions</strong> faster.
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-double-line text-green-400 text-xl"></i>
                </div>
                <div>
                  <strong className="text-red-200">Deal Evaluator Intelligence &amp; Machine Learning:</strong> Analyze feedback in real-time, prioritize high-value leads with <strong>deal evaluator</strong> precision and <strong>machine learning</strong>, and identify upsell opportunities automatically with <strong>AI automation</strong>.
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-double-line text-green-400 text-xl"></i>
                </div>
                <div>
                  <strong className="text-red-200">Business Automation AI &amp; Marketing Optimization:</strong> AI-driven advertising, <strong>marketing automation</strong>, and content creation that improves targeting and increases conversion rates for <strong>Charlotte NC businesses</strong> through <strong>predictive modeling</strong>.
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-double-line text-green-400 text-xl"></i>
                </div>
                <div>
                  <strong className="text-red-200">AI Expert Workflow Automation &amp; Process Optimization:</strong> Identify bottlenecks, track deadlines, and automate task assignments to optimize your operations with <strong>business transformation</strong>, <strong>process automation</strong>, and <strong>operational efficiency</strong>.
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/635f370d7165716b375345ba8c0a2ec9.jpg"
              alt="AI Business Analytics Dashboard showing revenue charts and data visualizations"
              title="AI Business Intelligence Dashboard - Curtis Waters AI Solutions"
              className="rounded-lg shadow-2xl object-cover w-full h-80"
              loading="lazy"
              width="600"
              height="400"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-red-900/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
